module.exports = __webpack_public_path__ + "img/product-box-mobile.f4ad65be.png";